export default "__VITE_ASSET__2WGDfNIF__"